module.exports = __webpack_public_path__ + "static/media/2418a824-3af2-42d7-a62e-f7a77cf487d1.f2ccacd1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/2418a824-3af2-42d7-a62e-f7a77cf487d1.woff2
// module id = 94
// module chunks = 0